import mixpanel from 'mixpanel-browser';

export type IdTokenPayload = {
  sub: string;
  'cognito:username': string;
};

// ログイン中のユーザーを Mixpanel に知らせる。
//
// distinct_id には Cognito の sub を使う。sub は1ユーザーに1つだけ割り当てられ、
// ユーザー名を変えても変わらないため、識別子として安定している。
//
// メールアドレスは渡さない。分析では使っておらず、ユーザーの識別は sub と
// ユーザー名で足りる。外部サービスに渡す個人データは必要な範囲に限る。
//
// mixpanel.alias() はここでは呼ばない。alias は新しい識別子を1度だけ登録するための
// API で、mixpanel-browser は $create_alias を送ったあとに identify(alias) を
// 呼び直す。この処理はセッションを復元するたびに走るので、alias を呼ぶと
// $create_alias が毎回送られ、そのうえ直前の identify(sub) が上書きされて
// distinct_id がユーザー名に変わってしまう。
const identifyUser = (idTokenPayload: IdTokenPayload): void => {
  mixpanel.identify(idTokenPayload.sub);
  mixpanel.people.set('$name', idTokenPayload['cognito:username']);
};

export default identifyUser;
